import type { TourConfig } from '../../types/tour.types'

const preferredTitleTour: TourConfig = {
  id: 'preferred-title',
  title: 'Set up a preferred title',
  module: 'Settings',
  routeName: 'PreferredTitleCreate',
  order: 8,
  autoStart: true,
  featureFlag: 'enablePreferredTitles',
  steps: [
    {
      id: 'intro',
      title: 'Always export the right people',
      body: 'A preferred title is a **reusable rule for who you export** — the titles, departments, levels and countries that matter to you. Set it once and every export prioritises the contacts you actually want to reach.',
    },
    {
      id: 'identity',
      target: '[data-tour="pt-identity"]',
      placement: 'bottom',
      title: 'Give it a name you\'ll recognise',
      body: 'This is just a label for you — like *"VP Sales & Marketing"* or *"Decision Makers EU"* — so you can pick the right rule later. Make it unique and descriptive.',
    },
    {
      id: 'criteria',
      target: '[data-tour="pt-criteria"]',
      placement: 'top',
      title: 'Define who counts',
      body: 'This is the heart of it. Set the **job titles**, **departments**, **contact levels** and **countries** to prioritise on export. Add as much or as little as you like — leave a field empty to include everyone for it.',
    },
    {
      id: 'behavior',
      target: '[data-tour="pt-behavior"]',
      placement: 'top',
      title: 'What to do when there\'s no exact match',
      body: 'Turn this **on** and TAMI tops up with the best available contacts when it can\'t find enough exact matches — so you\'re never left with an empty export. **Off** means strictly your criteria, nothing else.',
    },
    {
      id: 'save',
      target: '.ptu-actions__btn--save',
      placement: 'top',
      optional: true,
      title: 'Save and reuse it',
      body: 'Create the preferred title and it becomes available on your exports from now on — no need to reset these filters every time.',
    },
  ],
}

export default preferredTitleTour
